import VanguardConfig from '../../../config/vanguard';

/**
 * Tracking Service
 * Simply push some datas into the dataLayer
 */
export default class TrackingService {
  constructor() {
    this.marketingCloudId = '';
    this.trackPageView = {};
    this.trackConversionCart = [];
    this.trackConversionOther = {};
    this.userInfo = {};
  }

  /**
   * Push Data into the dataLayer
   * this.$store.getterss
   * @return {[type]} [description]
   */
  static pushEntryPointData(data) {
    if (window && window.dataLayer) {
      window.dataLayer.push(data);
    }
  }

  /**
   * Push Data into the dataLayer
   * this.$store.getterss
   * @return {[type]} [description]
   */
  static pushConfirmationData(data) {
    // Add default values
    data = Object.assign({
      quantity: 1,
      currency: VanguardConfig.currencyIsoCode
    }, data);

    if (window && window.dataLayer) {
      window.dataLayer.push(data);
    }
  }

  setMarketingCloudId(marketingCloudId) {
    this.marketingCloudId = marketingCloudId;
  }

  getMarketingCloudId() {
    return this.marketingCloudId;
  }

  addTrackPageViewItem(key, value) {
    this.trackPageView[key] = value;
  }

  getTrackPageViewItem() {
    return this.trackPageView;
  }

  setTrackConversionCart(item) {
    this.trackConversionCart.push(item);
  }

  getTrackConversionCart() {
    return this.trackConversionCart;
  }

  addTrackConversionOtherItem(key, value) {
    this.trackConversionOther[key] = value;
  }

  getTrackConversionOtherItem() {
    return this.trackConversionOther;
  }

  setUserInfoItem(key, value) {
    this.userInfo[key] = value;
  }

  getUserInfo() {
    return this.userInfo;
  }
}



// WEBPACK FOOTER //
// ./src/common/services/tracking.js